import ExampleQuestionPanel from '../ExampleQuestionPanel';
import ExampleQuestionsPanelToggle from '../ExampleQuestionsPanelToggle/ExampleQuestionsPanelToggle';
import ExampleQuestionsShortcutBar from '../ExampleQuestionsShortcutBar/ExampleQuestionsShortcutBar';
import { EQuestionPanelFocusTarget } from '../types';
import useQuestionPanel from '../useQuestionPanel';
import { ComposerPanelLayer } from './ExampleQuestionPanelEntry.styles';
import { TExampleQuestionPanelEntryProps } from './types';

// INFO: The component holding the entire logic for displaying the example question UI/UX
const ExampleQuestionPanelEntry = ({
  isDisabled,
  isOnboarding,
  isLoading,
  shouldShowEmptyState,
  handleSend,
}: TExampleQuestionPanelEntryProps) => {
  const state = useQuestionPanel({ shouldShowEmptyState, isOnboarding, isLoading, handleSend });

  // INFO: An Unstarted Thread is laid out centred, which puts the panel below the Chat Composer. Whether
  // the viewport is tall enough for that is decided in CSS, by the query the layer and the panel share.
  const isBelowComposer = Boolean(shouldShowEmptyState);

  return (
    <>
      <ComposerPanelLayer $isBelowComposer={isBelowComposer}>
        <ExampleQuestionPanel
          isOpen={state.isPanelOpen}
          isOnboarding={isOnboarding}
          isBelowComposer={isBelowComposer}
          activeCategory={state.activeCategory}
          searchValue={state.searchValue}
          faqsList={state.faqsList}
          shouldClaimFocus={state.pendingFocus === EQuestionPanelFocusTarget.PANEL}
          onClose={state.closePanel}
          onFilterChange={state.setFilterFromPanel}
          onSearchChange={state.setSearchValue}
          onSelectQuestion={state.selectQuestion}
          onFocusClaimed={state.consumePendingFocus}
        />

        {state.isShortcutBarVisible ? (
          <ExampleQuestionsShortcutBar
            hasDraft={state.hasDraft}
            isDisabled={isDisabled}
            isOnboarding={isOnboarding}
            shouldRestoreFocus={state.pendingFocus === EQuestionPanelFocusTarget.SHORTCUT}
            focusCategory={state.originCategory}
            onSelectCategory={state.selectCategory}
            onFocusRestored={state.consumePendingFocus}
          />
        ) : null}
      </ComposerPanelLayer>

      {state.isPanelToggleVisible ? (
        <ExampleQuestionsPanelToggle
          isPanelOpen={state.isPanelOpen}
          isDisabled={isDisabled}
          shouldRestoreFocus={state.pendingFocus === EQuestionPanelFocusTarget.TOGGLE}
          onOpen={state.openPanel}
          onClose={state.closePanel}
          onFocusRestored={state.consumePendingFocus}
        />
      ) : null}
    </>
  );
};

export default ExampleQuestionPanelEntry;
